/** Which Estate Map row an asset belongs in. Extracted from EstateMap.tsx so it is testable. */
export type EstateBucket = 'cloud' | 'database' | 'fileserver' | 'saas' | 'endpoint' | 'mainframe' | 'other';

export function estateBucketFor(sourceType: string | undefined, label: string): EstateBucket {
  const st = (sourceType ?? '').toLowerCase();
  const lb = (label ?? '').toLowerCase();
  if (st.indexOf('endpoint') >= 0 || lb.indexOf('laptop-') === 0 || label.indexOf(String.fromCharCode(92)) >= 0) return 'endpoint';
  if (lb.indexOf('s3://') === 0 || lb.indexOf('azureblob://') === 0 || st.indexOf('s3') >= 0 || st.indexOf('blob') >= 0) return 'cloud';
  if (lb.indexOf('m365sp://') === 0 || st.indexOf('sharepoint') >= 0 || st.indexOf('m365') >= 0) return 'saas';
  if (lb.indexOf('smb://') === 0 || st.indexOf('smb') >= 0 || st.indexOf('nfs') >= 0) return 'fileserver';
  // Before the database check: IBM i is a database too, but it lands in "Other"
  // today because nothing in the database test matches "db2i".
  if (st === 'db2i' || st === 'copybook_file' || lb.indexOf('db2i://') === 0 || lb.indexOf('copybook://') === 0) return 'mainframe';
  if (/^(pg|mysql|mssql|mongo|oracle|snowflake|redshift)\./.test(lb) || st.indexOf('postgres') >= 0 || st.indexOf('sql') >= 0 || st.indexOf('mongo') >= 0) return 'database';
  return 'other';
}
